import React, { useState, useCallback } from 'react';
import DropModal from 'components/shared/DropModal/DropModal';
import Checkbox from 'components/shared/Checkbox/Checkbox';
import { TimeSelect } from 'components/shared/TimeSelect';
import { generateFiltersBarData } from '../DMActionsTable/utils';
import styles from './DMActionsFiltersBar.module.css';

const DMActionsFiltersBar = ({ deviceIds, statuses, dateRange, onChange }) => {
  const [filtersData, setFiltersData] = useState(generateFiltersBarData(deviceIds, statuses, dateRange));

  const handleCheckBoxOnClick = (idx, id, optionName, isSelected) => {
    const newFiltersData = JSON.parse(JSON.stringify(filtersData));
    newFiltersData[idx].selection[optionName].selected = !isSelected;

    onChange(newFiltersData[idx]);

    setFiltersData(newFiltersData);
  };

  const handleCalendarOnSubmit = (value) => {
    const { span, from, to } = value;

    const newFiltersData = JSON.parse(JSON.stringify(filtersData));
    newFiltersData[1].selection = span ? { span: span } : { from, to };

    onChange(newFiltersData[1]);

    setFiltersData(newFiltersData);
  };

  const getActiveFilterItems = useCallback(
    (idx) => {
      const data = filtersData[idx];

      const activeItems = Object.keys(data.selection).filter((key) => data.selection[key].selected);

      return activeItems?.length > 0 ? activeItems : undefined;
    },
    [filtersData]
  );

  const handleClearFilterItems = useCallback((idx) => {
    const newFiltersData = JSON.parse(JSON.stringify(filtersData));
    const data = newFiltersData[idx];
    switch (data.id) {
      case 'device_id':
        Object.keys(data.selection).forEach((key) => {
          data.selection[key].selected = false;
        });
        onChange(data);
        setFiltersData(newFiltersData);
        return;
      case 'status':
        Object.keys(data.selection).forEach((key) => {
          data.selection[key].selected = false;
        });
        onChange(data);
        setFiltersData(newFiltersData);
        return;
      default:
        return;
    }
  }, []);

  return (
    <div className={styles.root}>
      <div className={styles.header}>Filter by:</div>
      <div className={styles.content}>
        {filtersData.map((data, idx) => {
          return (
            <div className={styles.dropModal} key={data.id}>
              {data.type === 'date' ? (
                <TimeSelect
                  className={styles.timeSelect}
                  value={dateRange}
                  onChange={handleCalendarOnSubmit}
                  direction="left"
                  hideArrow={true}
                />
              ) : (
                <DropModal
                  title={data.title}
                  name={`user_actions_${data.title}`}
                  isFilterBox={true}
                  activeFilterItems={getActiveFilterItems(idx)}
                  onClose={() => handleClearFilterItems(idx)}
                >
                  {data.options.map((option) => {
                    const isSelected = data.selection[option].selected;
                    return (
                      <div
                        key={option}
                        className={styles.option}
                        onClick={() => handleCheckBoxOnClick(idx, data.id, option, isSelected)}
                      >
                        <Checkbox isChecked={isSelected} />
                        <div className={styles.text}>{option}</div>
                      </div>
                    );
                  })}
                </DropModal>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DMActionsFiltersBar;
